import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "../Tooltip";
import { Info } from "lucide-react";

function BoolToggle({ size = "small", label, boolValue, onChange, tooltipText, ...props }) {
  const classes = useStyles();

  const handleToggle = () => {
    onChange(!boolValue);
  };

  return (
    <button
      disabled={props.disabled}
      className={props.disabled ? classes.toggleButtonDisabled : classes.toggleButton}
      onClick={() => handleToggle()}
      style={{
        height: size === "large" ? "40px" : "32px",
        paddingLeft: size === "large" ? "12px" : "8px",
        paddingRight: size === "large" ? "12px" : "6px",
        gap: size === "large" ? "12px" : "8px",
      }}
    >
      {tooltipText ? (
        <Tooltip content={tooltipText}>
          <Info size={14} className={classes.infoTooltipIcon} />
        </Tooltip>
      ) : null}
      <label
        className={props.disabled ? classes.labelDisabled : classes.label}
        style={{
          fontSize: size === "large" ? "16px" : "14px",
        }}
      >
        {label}
      </label>
      <div
        className={clsx(classes.toggleContainer, {
          [classes.activeContainer]: boolValue && !props.disabled,
          [classes.toggleContainerDisabled]: props.disabled,
        })}
      >
        <div
          className={clsx(classes.toggleCircle, {
            [classes.activeCircle]: boolValue && !props.disabled,
            [classes.toggleCircleDisabled]: props.disabled,
          })}
        ></div>
      </div>
    </button>
  );
}
export default BoolToggle;

const useStyles = makeStyles((theme) => ({
  toggleButton: {
    height: "28px",
    width: "fit-content",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",

    borderRadius: "4px",
    border: "1px solid #DCDCDC",

    backgroundColor: "white",

    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: "#0C0E29",

    paddingLeft: "8px",
    paddingRight: "6px",

    "&:hover": {
      cursor: "pointer",
    },
  },
  toggleButtonDisabled: {
    height: "28px",
    width: "fit-content",

    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",

    borderRadius: "4px",
    border: "1px solid #EDEDED",

    backgroundColor: "#EDEDED",

    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    color: "#bebfc4",

    paddingLeft: "8px",
    paddingRight: "6px",

    "&:hover": {
      cursor: "not-allowed",
    },
  },

  label: {
    fontSize: "14px",
    color: "#0C0E29",

    whiteSpace: "nowrap",

    "&:hover": {
      cursor: "pointer",
    },
  },
  labelDisabled: {
    fontSize: "14px",
    color: "#BDBDBD",

    "&:hover": {
      cursor: "not-allowed",
    },
  },

  toggleContainer: {
    width: "38px",
    height: "20px",
    boxSizing: "border-box",

    display: "flex",
    alignItems: "center",
    padding: "1px",

    borderRadius: "10px",

    backgroundColor: "#EDEDED",

    position: "relative",
    transition: "background-color 0.3s ease",
  },

  toggleContainerDisabled: {
    backgroundColor: "#DCDCDC",
  },

  activeContainer: {
    backgroundColor: "#E2F8E0",
  },

  toggleCircle: {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    backgroundColor: "#BDBDBD",
    position: "absolute",
    left: "1px",
    transition: "left 0.3s ease",
  },

  toggleCircleDisabled: {
    backgroundColor: "#BDBDBD",
  },

  activeCircle: {
    left: "18px", // Moves the toggle circle to the right
    backgroundColor: "#5CC958", // Green color for the circle when active
  },

  infoTooltipIcon: {
    color: "inherit",
    opacity: .8,
    display: "block",
    lineHeight: 0,
    verticalAlign: "top"
  },
}));
